import logo from "./logo.svg";
import "./App.scss";
import "./Particle.css";
import Awards from "./awards";
import {
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import { Dialog } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import React from "react";
import StoreIcon from "@material-ui/icons/Store";
import TouchAppOutlinedIcon from "@material-ui/icons/TouchAppOutlined";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import profilePic from "../src/sticker.webp";
function App() {
  const [imgDialogOpen, setImgDialogOpen] = useState(false);
  const [imgLink, setImgLink] = useState("");
  const [description, setDescription] = useState("");
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState("flex");
  const [fontSize, setFontSize] = useState("null");
  const [leftMargin, setLeftMargin] = useState("3rem");
  const [contactLeftMargin, setContactLeftMargin] = useState("1rem");
  const scrollToSummary = (event: any) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    if (window.innerWidth < 500) {
      setDisplay("table");
      setFontSize("11pt");
      setLeftMargin("15pt");
      setContactLeftMargin("0rem");
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const closeDialog = () => {
    setImgLink("");
    setImgDialogOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  return (
    <div id="nc-main" className="nc-main bg-cover bg-cc">
      <div className="full-wh">
        <div className="bg-animation">
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <div id="stars4"></div>
          {window.innerWidth > 500 ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "right",
                  marginRight: "3rem",
                }}
              >
                <div className="container">
                  <div className="neon">developer </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  flex: 2,
                  textAlign: "right",
                  marginRight: "3rem",
                  display: "flex",
                  marginTop: "3rem",
                  marginBottom: "-2rem",
                }}
              >
                <a
                  href="https://jaebeenlee.notion.site/64d2428e43fe43bd9e67174bb811d18c"
                  target="_blank"
                >
                  <img
                    src={profilePic}
                    alt="Portrait"
                    width="100%"
                    height="100pt"
                    className="card__image"
                    style={{
                      marginLeft: "2rem",
                      marginRight: "1rem",
                      borderRadius: "5%",
                      opacity: "0.85",
                      boxShadow: "0 0 8px 10px black",
                    }}
                  />
                </a>
                <div className="container">
                  <div
                    className="neon"
                    style={{ fontSize: "8.5vw", paddingTop: "1rem" }}
                  >
                    developer{" "}
                  </div>
                </div>
              </div>
            </>
          )}
          <div
            style={{
              display: display,
              flex: 1,
              marginLeft: leftMargin,
              marginTop: "3rem",
              marginBottom: "5rem",
            }}
          >
            <div>
              {window.innerWidth > 500 ? (
                <>
                  <a
                    href="https://jaebeenlee.notion.site/64d2428e43fe43bd9e67174bb811d18c"
                    target="_blank"
                  >
                    <img
                      src={profilePic}
                      alt="Portrait"
                      width="100%"
                      height="230px"
                      className="card__image"
                      style={{ borderRadius: "5%" }}
                    />
                  </a>
                </>
              ) : (
                <> </>
              )}
            </div>
            {window.innerWidth > 500 ? (
              <>
                <div
                  style={{
                    color: "white",
                    marginLeft: leftMargin,
                    fontSize: fontSize,
                  }}
                >
                  <h1>LEE JAE BEEN</h1>
                  <div> 현대자동차 회원플랫폼 개발팀</div>
                  <div> (전)티맥스 소프트 (2020.12 ~ 2022.01)</div>
                  <div> 경희대학교 컴퓨터공학과 학사</div>
                  <div> KCC2020 한국 정보 과학회 우수논문상 수상</div>
                  <div>
                    {" "}
                    한국인터넷진흥원 주관 제8회 핀테크해커톤 우수상 수상
                  </div>
                  <div> 과학기술정보통신부 주관 마이해커톤 우수상 수상</div>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    color: "white",
                    fontSize: "10pt",
                  }}
                >
                  <h1>LEE JAE BEEN</h1>
                  <div> 현대자동차 회원플랫폼 개발팀</div>
                  <div> (전)티맥스 소프트(2020.12 ~ 2022.01)</div>
                  <div> 경희대학교 컴퓨터공학과 학사</div>
                  <div> KCC2020 한국 정보 과학회 우수논문상 수상</div>
                  <div>
                    {" "}
                    한국인터넷진흥원 주관 제8회 핀테크해커톤 우수상 수상
                  </div>
                  <div> 과학기술정보통신부 주관 마이해커톤 우수상 수상</div>
                </div>
              </>
            )}

            {window.innerWidth > 500 ? (
              <>
                <div
                  style={{
                    color: "white",
                    marginRight: "10rem",
                    float: "right",
                    marginLeft: "auto",
                    textAlign: "right",
                    fontSize: fontSize,
                  }}
                >
                  <h1>Introduce</h1>
                  문제파악부터 설계, 평가까지의 <br />
                  복잡한 프로세스를 거쳐 만든 프로그램이 <br /> 좋은 평가를 받을
                  때,
                  <br />그 어떤 일보다 <strong>큰</strong> 성취감을 느낍니다.
                  <br />
                  읽기 쉬운 코드, 모듈화가 쉬운 코드를 지향하며
                  <br />
                  꾸준히 성장하는 개발자가 되고싶습니다.
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    color: "white",
                    float: "left",
                    textAlign: "left",
                    marginTop: "1rem",
                    fontSize: "10pt",
                  }}
                >
                  <h1>Introduce</h1>
                  문제파악부터 설계, 평가까지의 <br />
                  복잡한 프로세스를 거쳐 만든 프로그램이 <br /> 좋은 평가를 받을
                  때,
                  <br />그 어떤 일보다 <strong>큰</strong> 성취감을 느낍니다.
                  <br />
                  읽기 쉬운 코드, 모듈화가 쉬운 코드를 지향하며
                  <br />
                  꾸준히 성장하는 개발자가 되고싶습니다.
                </div>
              </>
            )}
          </div>
          <div
            style={{
              color: "white",
              flex: 1,
              marginLeft: leftMargin,
              marginBottom: "5rem",
              fontSize: fontSize,
            }}
          >
            {window.innerWidth > 500 ? (
              <>
                <h1>PROJECT</h1>
              </>
            ) : (
              <>
                <h1>
                  PROJECT <SwapHorizIcon />
                </h1>
              </>
            )}
            <TableContainer style={{ maxWidth: "98%", height: "fit-content" }}>
              <Table size="small">
                <TableRow hover={true}>
                  <TableCell align="center">Number </TableCell>
                  <TableCell align="center">Title </TableCell>
                  <TableCell align="center">Period </TableCell>
                  <TableCell align="center">Role </TableCell>
                  <TableCell align="center">Stacks </TableCell>
                  <TableCell align="center">Description </TableCell>
                  <TableCell align="center">Repository </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">1 </TableCell>
                  <TableCell align="center">
                    개인정보 비식별 조치 모듈 개발
                  </TableCell>
                  <TableCell align="center"> 2020.12.28~2021.03.25</TableCell>
                  <TableCell align="center">기획, 연구, 개발, 통합</TableCell>
                  <TableCell align="center">
                    ARX, SpringBoot, TiberoDB, React.js
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        handleClickOpen();
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      style={{ color: "white" }}
                      onClick={() => {
                        handleClickOpen();
                      }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">2 </TableCell>
                  <TableCell align="center">주가 예측 서비스</TableCell>
                  <TableCell align="center"> 2020.09.18~2020.09.21</TableCell>
                  <TableCell align="center">BackEnd,Integration</TableCell>
                  <TableCell align="center">
                    React.js, SpringBoot, Aws RDS, NCP
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://github.com/woqls22/StockNews/raw/master/BackEnd/PythonScripts/Resources/Demo.gif"
                        );
                        setDescription(
                          "뉴스 데이터를 분석하여 종목의 주가 상승 및 하락을 예측하는" +
                            " 웹서비스를 구현했습니다. 백엔드 모듈, 뉴스데이터 크롤링 모듈" +
                            " 작성, 예측모델 학습 및 구축, 모듈 통합, 클라우드 서버 임포트" +
                            " 작업을 진행했습니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"https://github.com/woqls22/StockNews"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">3 </TableCell>
                  <TableCell align="center">
                    이미지 스캔 웹서비스 구현
                  </TableCell>
                  <TableCell align="center"> 2020.05.11~2020.06.14</TableCell>
                  <TableCell align="center">기획, 개발, 배포</TableCell>
                  <TableCell align="center">
                    Pytesseract, OpenCV, Express.js, AWS ec2, React.js, Naver
                    Papago API
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://github.com/woqls22/OSS_Project/raw/master/src/1.JPG"
                        );
                        setDescription(
                          "사용자로부터 이미지를 업로드받고, 사진을 바탕으로 서류를" +
                            " 스캔해주는 서비스를 구현했습니다. OCR라이브러리를 활용하여" +
                            " 이미지로부터 Text를 추출, 파파고 api를 통해 번역기능을" +
                            " 구현하였습니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"https://github.com/woqls22/OSS_Project"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">4 </TableCell>
                  <TableCell align="center">
                    인물 사진 바탕 화장 및 Clothes Swap
                  </TableCell>
                  <TableCell align="center"> 2020.07.13~2020.08.18</TableCell>
                  <TableCell align="center">기획, 개발</TableCell>
                  <TableCell align="center">Python, OpenCV, dlib</TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://github.com/woqls22/MakeUpProject/raw/master/Resources/makeup.PNG"
                        );
                        setDescription(
                          " 인물사진을 바탕으로 make up을 진행하며, 사용자의 설정값에 따라 각 Face Part Layer를 추출하는 프로젝트입니다. MakeUp모듈, Hair Segmentation, FacePart Layer Extraction 기능을 개발했습니다.이외에도 Clothes Swap기능을 구현하였습니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"https://github.com/woqls22/MakeUpProject"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">5 </TableCell>
                  <TableCell align="center">
                    자율주행카트 영상처리 기반 시뮬레이션 프로젝트
                  </TableCell>
                  <TableCell align="center"> 2020.07.12~2020.08.02</TableCell>
                  <TableCell align="center">기획, 개발</TableCell>
                  <TableCell align="center">OpenCV,Yolo v3, Python</TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://github.com/woqls22/Autonomus-Vehicle/raw/master/Scripts/Resources/test.gif"
                        );
                        setDescription(
                          " 자율주행 카트에서의 영상처리 모듈을 개발하였습니다." +
                            " OpenCV를 활용하여 자율주행 모듈을 개발, Ros시뮬레이션 주행에 적용하였습니다." +
                            " 차선인식모듈과 장애물인식모듈, HW제어 모듈을 구현하였습니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"https://github.com/woqls22/Autonomus-Vehicle"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">6 </TableCell>
                  <TableCell align="center">
                    HyperData Meta Management 개발
                  </TableCell>
                  <TableCell align="center"> 2021.04.01~2021.07.01</TableCell>
                  <TableCell align="center">기획, 연구, 개발</TableCell>
                  <TableCell align="center">TiberoDB, React.js, JAVA</TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        handleClickOpen();
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={""}
                      target="_blank"
                      style={{ color: "white" }}
                      onClick={() => handleClickOpen()}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">7 </TableCell>
                  <TableCell align="center">
                    Chrome Extension : 코인가격정보 제공 프로그램 개발
                  </TableCell>
                  <TableCell align="center"> 2021.05.17~2021.05.18</TableCell>
                  <TableCell align="center">기획, 개발</TableCell>
                  <TableCell align="center">
                    TypeScript,React.js, Upbit API
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://github.com/woqls22/chrome_coin/raw/main/demo4.gif"
                        );
                        setDescription(
                          "거래소 방문없이, 코인 가격을 쉽게 파악할 수 있는 크롬 확장프로그램을 개발했습니다. Upbit API를 사용하여 실시간으로 가상화폐 거래 가격을 제공합니다. 현재 chrome_coin이름으로 크롬 웹스토어에 게시되어 배포중입니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"https://github.com/woqls22/chrome_coin"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">8 </TableCell>
                  <TableCell align="center">인생N컷</TableCell>
                  <TableCell align="center"> 2021.06.01~2021.06.08</TableCell>
                  <TableCell align="center">기획, 개발</TableCell>
                  <TableCell align="center">
                    TypeScript,React.js, Mysql DB, Spring Security, Spring Data,
                    JPA
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fblog.kakaocdn.net%2Fdn%2FbiWcBZ%2Fbtq6FuJje8O%2Fxy2HkwjEzh6xkHc17s4EIk%2Fimg.png"
                        );
                        setDescription(
                          "Private 앨범 서비스인 인생N컷을 기획, 개발중입니다. 개인 앨범을 통해 지인들과 추억을 공유할 수 있으며, 버킷리스트를 만들고 확인할 수 있는 웹 어플리케이션입니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"http://life-n-cut.site/"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">9 </TableCell>
                  <TableCell align="center">지금어디야?</TableCell>
                  <TableCell align="center"> 2022.05.24~2022.06.06</TableCell>
                  <TableCell align="center">기획, 개발</TableCell>
                  <TableCell align="center">
                    React.js, Typescript, SpringBoot, Kafka, docker
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://camo.githubusercontent.com/caf13caa4bd25e49107b2e2594f16fa720361517af4df91e8db1812edd824e2b/687474703a2f2f696d672e796f75747562652e636f6d2f76692f6a6c6949383761563776492f302e6a7067"
                        );
                        setDescription(
                          "같은 링크에 접속한 사용자들의 현위치를 실시간으로 공유할 수 있는 서비스입니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"https://github.com/woqls22/where-r-u-now-"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">10 </TableCell>
                  <TableCell align="center">Medical Link</TableCell>
                  <TableCell align="center"> 2022.06.15~2022.06.28</TableCell>
                  <TableCell align="center">기획, 백엔드 개발</TableCell>
                  <TableCell align="center">
                    SpringBoot, Mysql, JPA, docker
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => {
                        setImgLink(
                          "https://mblogthumb-phinf.pstatic.net/MjAyMjA2MjZfMTQx/MDAxNjU2MjQ2MTg1ODQ2.sxIZZaQ-rRvbYxJf-AySJsOL52HepD1jrd49Y4YSIuAg.YLxsRMcCB4AHTzDAm256HJwM-RvVDgrw10lo2SovpBYg.PNG.woqls22/image.png?type=w800"
                        );
                        setDescription(
                          "암환자를 위한 임상시험 추천 플랫폼입니다. 마이데이터 해커톤에서 제공하는 마이데이터를 활용하였습니다."
                        );
                        setImgDialogOpen(true);
                      }}
                      style={{ color: "white" }}
                    >
                      <TouchAppOutlinedIcon />
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      href={"https://youtu.be/GpnOBp40dXM"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <StoreIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </div>
          <Dialog
            open={imgDialogOpen}
            onClose={closeDialog}
            aria-labelledby="form-dialog-title"
            maxWidth={"md"}
            style={{ color: "white" }}
          >
            <DialogTitle id="form-dialog-title">
              <strong>PROJECT IMG</strong>
            </DialogTitle>
            <DialogContent>
              <div
                style={{ display: display, width: "100%", fontSize: fontSize }}
              >
                <img
                  src={imgLink}
                  style={{ width: "100%", maxHeight: "30rem" }}
                  alt="project"
                />
              </div>
              <div>
                <h1>설명</h1>
                {description}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog}>확인</Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Project Info"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                사규정으로 인해 관련 정보 제공이 어렵습니다.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary" autoFocus>
                확인
              </Button>
            </DialogActions>
          </Dialog>
          <br />
          <br />
          <div style={{ flex: 1, color: "white", marginLeft: leftMargin }}>
            <h1>STACKS</h1>
            <div style={{ display: display, fontSize: fontSize }}>
              <div style={{ flex: 1, marginRight: "1rem" }}>
                <div style={{ color: "white" }}>
                  <ul>
                    <li>
                      <img
                        src="https://s3.ap-northeast-2.amazonaws.com/grepp-cloudfront/programmers_imgs/learn/thumb-course-java-intermediate.jpg"
                        width="100%"
                        height="170"
                      />
                    </li>
                    <li>
                      <h2>JAVA</h2>
                    </li>
                    <li>
                      인터페이스, 추상클래스등의 개념을 이해하고 있으며, 자바
                      메모리구조를 이해하고 있습니다.
                    </li>
                    <li>
                      스프링 프레임워크에서 JDBC, JPA를 통한 RDBMS기반의
                      웹개발(API시스템 개발)을 할 수 있습니다.
                    </li>
                  </ul>
                </div>
              </div>
              <div style={{ marginRight: "1rem", flex: 1 }}>
                <div style={{ color: "white" }}>
                  <ul>
                    <li>
                      <img
                        src="https://miro.medium.com/max/2400/0*XCgoYU9sqt95P8J0.png"
                        width="100%"
                        height="170"
                      />
                    </li>
                    <li>
                      <h2>React</h2>
                    </li>
                    <li>
                      MOBX 상태 관리를 하며 AXIOS를 사용하여 API 요청을 구현할
                      수 있습니다.
                    </li>
                    <li>
                      대부분의 필요한 웹 컴포넌트를 개발할 수 있습니다.
                      react-flow-renderer를 활용한 Flow 시각화 개발 경험이
                      있습니다.
                    </li>
                  </ul>
                </div>
              </div>
              <div style={{ marginRight: "1rem", flex: 1 }}>
                <div style={{ color: "white" }}>
                  <ul>
                    <li>
                      <img
                        src="https://cdn.inflearn.com/wp-content/uploads/spring_ver.2018-1.jpg"
                        width="100%"
                        height="170"
                      />
                    </li>
                    <li>
                      <h2>Spring FrameWork</h2>
                    </li>
                    <li>
                      스프링 프레임워크의 구조에 대해 이해하고 있으며, JPA를
                      활용한 CRUD API를 개발할 수 있습니다. Spring Context를
                      이해하고 활용할 수 있으며 Filter, Interceptor, aop등을
                      통한 로직 분리를 할 수 있습니다.
                    </li>
                  </ul>
                </div>
              </div>
              <div style={{ flex: 1, marginRight: "1rem" }}>
                <div style={{ color: "white" }}>
                  <ul>
                    <li>
                      <img
                        src="https://img1.daumcdn.net/thumb/R800x0/?scode=mtistory2&fname=https%3A%2F%2Ft1.daumcdn.net%2Fcfile%2Ftistory%2F9954F3355BBF0F0724"
                        width="100%"
                        height="170"
                      />
                    </li>
                    <li>
                      <h2>Oracle</h2>
                    </li>
                    <li>
                      DB 정규화, 인덱싱등의 기초 개념을 이해하고 있으며
                      RDB스키마를 설계할 수 있습니다.
                    </li>
                    <li>
                      쿼리를 사용하여 스키마를 직접 구현하며, JPA,JDBC를
                      연동하여 객체지향적 API를 개발 할 수 있습니다.
                    </li>
                  </ul>
                </div>
              </div>
              <div style={{ flex: 1, marginRight: "1rem" }}>
                <div style={{ color: "white" }}>
                  <ul>
                    <li>
                      <img
                        src="https://cdn.slidesharecdn.com/ss_thumbnails/15431-151208171634-lva1-app6891-thumbnail-4.jpg?cb=1449595199"
                        width="100%"
                        height="170"
                      />
                    </li>
                    <li>
                      <h2>ARX</h2>
                    </li>
                    <li>
                      개인정보 비식별 조치 오픈소스인 ARX를 활용할 수 있습니다.
                    </li>
                    <li>
                      속성정보에 따른 레코드 취약성을 검증할 수 있으며, 준식별자
                      조합에 대한 위험도를 측정하고 최적 솔루션을 제공할 수
                      있습니다.
                    </li>
                  </ul>
                </div>
              </div>
              <div style={{ flex: 1, marginRight: "1rem" }}>
                <div style={{ color: "white" }}>
                  <ul>
                    <li>
                      <img
                        src="https://t1.daumcdn.net/cfile/tistory/999399465F5084760F"
                        width="100%"
                        height="170"
                      />
                    </li>
                    <li>
                      <h2>JavaScript</h2>
                    </li>
                    <li>
                      ES6문법에 대해 이해하고 있으며 <br />
                      Promise객체에 대한 이해를 바탕으로 비동기 콜백문제를
                      해결할 수 있습니다
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: display,
              marginLeft: leftMargin,
              marginBottom: "5rem",
              fontSize: fontSize,
            }}
          >
            {/* <div style={{ flex: 1, marginRight: "1rem" }}>
              <div style={{ color: "white" }}>
                <ul>
                  <li>
                    <img
                      src="https://blog.kakaocdn.net/dn/6jJIy/btqD1qtPjLY/D0M6XwD68qoqr4ckIixb5k/img.png"
                      width="100%"
                      height="170"
                    />
                  </li>
                  <li>
                    <h2>Elastic Search</h2>
                  </li>
                  <li>사용 기간 : 1년</li>
                  <li>
                    Elastic Search의 Inverted Index Based 동작원리를 이해하고
                    있으며 RDBMS와의 차이점을 이해하고있습니다
                  </li>
                  <li>
                    Elastic Search를 기반으로 Json기반의 쿼리 조회 API를 작성할
                    수 있습니다.
                  </li>
                </ul>
              </div>
            </div> */}
            <div style={{ flex: 1, marginRight: "1rem" }}>
              <div style={{ color: "white" }}>
                <ul>
                  <li>
                    <img
                      src="https://dist.neo4j.com/wp-content/uploads/20210423062553/neo4j-social-share-21.png"
                      width="100%"
                      height="170"
                    />
                  </li>
                  <li>
                    <h2>Neo4j</h2>
                  </li>
                  <li>
                    그래프 데이터베이스인 Neo4j를 사용하여 데이터 모델링을 할 수
                    있습니다. Neo4j의 쿼리인 Cypher를 이해하고 사용할 수 있으며,
                    노드간 연관관계를 재귀적으로 탐색하여 기존 RDB에 비해 높은
                    검색 효율을 구현할 수 있습니다.
                  </li>
                  <li>
                    Neo4j의 apoc, n10s 플러그인을 통해 rdf 스키마를 import하고
                    이를바탕으로 검색 API를 구현할 수 있습니다.
                  </li>
                </ul>
              </div>
            </div>
            <div style={{ flex: 1, marginRight: "1rem" }}>
              <div style={{ color: "white" }}>
                {/* <ul>
                    <li>
                      <img
                        src="https://blog.kakaocdn.net/dn/6jJIy/btqD1qtPjLY/D0M6XwD68qoqr4ckIixb5k/img.png"
                        width="100%"
                        height="100%"
                      />
                    </li>
                    <li>
                      <h2>Elastic Search</h2>
                    </li>
                    <li>사용 기간 : 1년</li>
                    <li>
                    Elastic Search의 Inverted Index Based 동작원리를 이해하고 있으며 RDBMS와의 차이점을 이해하고있습니다
                    </li>
                    <li>Elastic Search를 기반으로 Json기반의 쿼리 조회 API를 작성할 수 있습니다.</li>
                  </ul> */}
              </div>
            </div>
            <div style={{ flex: 1, marginRight: "1rem" }}>
              <div style={{ color: "white" }}>
                {/* <ul>
                    <li>
                      <img
                        src="https://blog.kakaocdn.net/dn/6jJIy/btqD1qtPjLY/D0M6XwD68qoqr4ckIixb5k/img.png"
                       width="100%"
                        height="100%"
                      />
                    </li>
                    <li>
                      <h2>Elastic Search</h2>
                    </li>
                    <li>사용 기간 : 1년</li>
                    <li>
                    Elastic Search의 Inverted Index Based 동작원리를 이해하고 있으며 RDBMS와의 차이점을 이해하고있습니다
                    </li>
                    <li>Elastic Search를 기반으로 Json기반의 쿼리 조회 API를 작성할 수 있습니다.</li>
                  </ul> */}
              </div>
            </div>
            <div style={{ flex: 1, marginRight: "1rem" }}>
              <div style={{ color: "white" }}>
                {/* <ul>
                    <li>
                      <img
                        src="https://blog.kakaocdn.net/dn/6jJIy/btqD1qtPjLY/D0M6XwD68qoqr4ckIixb5k/img.png"
                       width="100%"
                        height="100%"
                      />
                    </li>
                    <li>
                      <h2>Elastic Search</h2>
                    </li>
                    <li>사용 기간 : 1년</li>
                    <li>
                    Elastic Search의 Inverted Index Based 동작원리를 이해하고 있으며 RDBMS와의 차이점을 이해하고있습니다
                    </li>
                    <li>Elastic Search를 기반으로 Json기반의 쿼리 조회 API를 작성할 수 있습니다.</li>
                  </ul> */}
              </div>
            </div>
            <div style={{ flex: 1, marginRight: "1rem" }}>
              <div style={{ color: "white" }}>
                {/* <ul>
                    <li>
                      <img
                        src="https://blog.kakaocdn.net/dn/6jJIy/btqD1qtPjLY/D0M6XwD68qoqr4ckIixb5k/img.png"
                       width="100%"
                        height="100%"
                      />
                    </li>
                    <li>
                      <h2>Elastic Search</h2>
                    </li>
                    <li>사용 기간 : 1년</li>
                    <li>
                    Elastic Search의 Inverted Index Based 동작원리를 이해하고 있으며 RDBMS와의 차이점을 이해하고있습니다
                    </li>
                    <li>Elastic Search를 기반으로 Json기반의 쿼리 조회 API를 작성할 수 있습니다.</li>
                  </ul> */}
              </div>
            </div>
          </div>

          <div
            style={{
              flex: 1,
              color: "white",
              marginLeft: leftMargin,
              fontSize: fontSize,
            }}
          >
            {window.innerWidth > 500 ? (
              <>
                <h1>Awards</h1>
              </>
            ) : (
              <>
                <h1>
                  Awards <SwapHorizIcon />
                </h1>
              </>
            )}
            <TableContainer style={{ maxWidth: "98%", height: "fit-content" }}>
              <Table size="small">
                <TableRow hover={true}>
                  <TableCell align="center">Number </TableCell>
                  <TableCell align="center">Title </TableCell>
                  <TableCell align="center">Sponsorship</TableCell>
                  <TableCell align="center">Awards </TableCell>
                  <TableCell align="center">Description </TableCell>
                  <TableCell align="center">Date </TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">1</TableCell>
                  <TableCell align="center">제 8회 핀테크 해커톤</TableCell>
                  <TableCell align="center">한국인터넷진흥원(KISA)</TableCell>
                  <TableCell align="center">우수상</TableCell>
                  <TableCell align="center">
                    뉴스데이터 분석을 통한 주가예측 서비스
                  </TableCell>
                  <TableCell align="center">2020.09.15</TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">2</TableCell>
                  <TableCell align="center">
                    2020 한국컴퓨터종합학술대회
                  </TableCell>
                  <TableCell align="center">
                    한국정보과학회(Korean Institute of Information Scientists
                    and Engineers)
                  </TableCell>
                  <TableCell align="center">우수논문상</TableCell>
                  <TableCell align="center">
                    실내 문서 전달 자율주행 카트 개발을 위한 객체 인지 및 충돌
                    방지 모듈 개발
                  </TableCell>
                  <TableCell align="center">2020.07</TableCell>
                </TableRow>
                <TableRow hover={true}>
                  <TableCell align="center">3</TableCell>
                  <TableCell align="center">My data Hackathon</TableCell>
                  <TableCell align="center">과학기술정보통신부</TableCell>
                  <TableCell align="center">우수상</TableCell>
                  <TableCell align="center">
                    암환자를 위한 임상시험 추천 플랫폼
                  </TableCell>
                  <TableCell align="center">2022.07</TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </div>
          <div
            style={{
              flex: 1,
              color: "white",
              marginLeft: leftMargin,
              marginBottom: "5rem",
              fontSize: fontSize,
            }}
          >
            <h1>CONTACT</h1>
            <div style={{ display: display, width: "100%" }}>
              <div
                style={{
                  flex: 1,
                  marginLeft: contactLeftMargin,
                  marginTop: "1rem",
                }}
              >
                <h1>Business Mail</h1>
                <ul>
                  <li>jaebeen_lee@hyundai.com</li>
                </ul>
              </div>
              <div
                style={{
                  flex: 1,
                  marginLeft: contactLeftMargin,
                  marginTop: "1rem",
                }}
              >
                <h1>Email</h1>
                <ul>
                  <li>woqls226@gmail.com</li>
                </ul>
              </div>
              <div style={{ flex: 1, marginLeft: contactLeftMargin }}>
                <ul>
                  <li>
                    <Button
                      href={"https://github.com/woqls22"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <h1>Github</h1>
                    </Button>
                  </li>
                </ul>
              </div>
              <div style={{ flex: 1, marginLeft: contactLeftMargin }}>
                <ul>
                  <li>
                    <Button
                      href={"https://blog.naver.com/woqls22"}
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <h1>Blog</h1>
                    </Button>
                  </li>
                </ul>
              </div>
              <div style={{ flex: 1, marginLeft: contactLeftMargin }}>
                <ul>
                  <li>
                    <Button
                      href={
                        "https://www.linkedin.com/in/%EC%9E%AC%EB%B9%88-%EC%9D%B4-3b12501b7/"
                      }
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <h1>LinkdIn</h1>
                    </Button>
                  </li>
                </ul>
              </div>
              <div style={{ flex: 1, marginLeft: contactLeftMargin }}>
                <ul>
                  <li>
                    <Button
                      href={
                        "https://jaebeenlee.notion.site/64d2428e43fe43bd9e67174bb811d18c"
                      }
                      target="_blank"
                      style={{ color: "white" }}
                    >
                      <h1>NOTION</h1>
                    </Button>
                  </li>
                </ul>
              </div>
              {/* <div style={{ flex: 1, marginLeft: contactLeftMargin }}>
                <ul>
                  <li>
                    <Button
                      onClick={scrollToSummary}
                      style={{ color: "white" }}
                    >
                      <h1>Move Up</h1>
                    </Button>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
